import { accordionState } from "../accordion";
import { ValidateUser } from "../validation/userValidation.js";
import { initState } from "./common";
import usersApiClient from "./UsersApiClient";
import { getCurrentLanguage } from "../utils/currentLanguage";
const initRegisterRequest = {
    Email: "",
    RepeatedEmail: "",
    Password: "",
    RepeatedPassword: "",
    PhoneNumber: "",
    FirstName: "",
    LastName: "",
    EmailName: "",
    StreetName: "",
    Line2: "",
    PostalCode: "",
    PostalCity: "",
    CountryId: 0,
    CountryCode: "",
    Region: "",
    Newsletter: null,
    TermsAccepted: false,
    ShippingServiceIdShop: 0,
    ShippingServiceIdAuction: 0,
};
const RegionRequiredCountries = ["US", "CA"];
export function getRegisterData(options) {
    var _a, _b;
    const shippingServicesShop = options.shippingServices.filter((x) => x.db == "SKF");
    const shippingServicesAuction = options.shippingServices.filter((x) => x.db == "SKA");
    const initCountry = options.countries.find((c) => c.isSelected);
    const initShippingServiceShop = shippingServicesShop[0];
    const initShippingServiceAuction = shippingServicesAuction[0];
    return {
        ...accordionState,
        ...initState,
        focused: false,
        registerData: {
            ...initRegisterRequest,
            CountryId: initCountry.id,
            CountryCode: initCountry.countryCode,
            ShippingServiceIdShop: (_a = initShippingServiceShop === null || initShippingServiceShop === void 0 ? void 0 : initShippingServiceShop.id) !== null && _a !== void 0 ? _a : 0,
            ShippingServiceIdAuction: (_b = initShippingServiceAuction === null || initShippingServiceAuction === void 0 ? void 0 : initShippingServiceAuction.id) !== null && _b !== void 0 ? _b : 0,
        },
        registrationComplete: false,
        selectedCountry: initCountry,
        selectedShippingServiceShop: initShippingServiceShop,
        selectedShippingServiceAuction: initShippingServiceAuction,
        countries: [...options.countries],
        shippingServicesShop: shippingServicesShop,
        shippingServicesAuction: shippingServicesAuction,
        sectionError: 999,
        $refs: {},
        checkIfCurrentIsValid(input, errorSpan) {
            const err = ValidateUser(this.registerData, input.name);
            const errMessage = err === undefined
                ? null
                : err[0].options !== undefined
                    ? err[0].options.message
                    : err[0];
            if (err) {
                errorSpan.innerText = errMessage;
                errorSpan.classList.add("show");
                this.errorMessage = errMessage;
                this.isValid = false;
                this.sectionError = parseInt(errorSpan.dataset.section);
            }
            else {
                this.isValid = true;
                errorSpan.classList.remove("show");
            }
        },
        goNext(idx = null) {
            const err = ValidateUser(this.registerData);
            if (err) {
                this.errorMessage =
                    err[0].options !== undefined ? err[0].options.message : err[0];
                const currentErrorSpan = this.$refs[`${err[0].attribute}Error`];
                currentErrorSpan.innerText = this.errorMessage;
                currentErrorSpan.classList.add("show");
                this.sectionError = currentErrorSpan.dataset.section;
                this.isValid = false;
            }
            else {
                this.errorMessage = "";
                this.sectionError = 999;
                this.isValid = true;
            }
            if (RegionRequiredCountries.includes(this.registerData.CountryCode) &&
                !this.registerData.Region) {
                const currentErrorSpan = this.$refs["RegionError"];
                currentErrorSpan.innerText =
                    getCurrentLanguage() === "no"
                        ? "Stat kan ikke være tomt"
                        : "State cannot be empty";
                currentErrorSpan.classList.add("show");
                this.sectionError = currentErrorSpan.dataset.section;
                this.isValid = false;
            }
            if (!this.registerData.TermsAccepted) {
                this.sectionError = 0;
                this.isValid = false;
            }
            const inxToGo = this.isValid ? idx !== null && idx !== void 0 ? idx : this.index + 1 : this.sectionError;
            this.sectionClick(Number(inxToGo));
        },
        submit() {
            this.isLoading = true;
            usersApiClient
                .register(this.registerData)
                .then(() => {
                var _a;
                this.registrationComplete = true;
                (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", "Registration-completed");
            })
                .catch((errResponse) => {
                var _a;
                this.isLoading = false;
                this.errorMessage = (_a = errResponse.data) === null || _a === void 0 ? void 0 : _a.message;
            });
        },
        getPostalCode(postalCode) {
            usersApiClient
                .getPostalDefinition(postalCode, this.registerData.CountryCode)
                .then((data) => {
                if (data) {
                    this.registerData.PostalCity = data.city;
                }
            });
        },
        selectCountry(country) {
            this.registerData.CountryId = country.id;
            this.registerData.CountryCode = country.countryCode;
            this.selectedCountry = country;
        },
        selectShippingServiceShop(shippingService) {
            this.registerData.ShippingServiceIdShop = shippingService.id;
            this.selectedShippingServiceShop = shippingService;
        },
        selectShippingServiceAuction(shippingService) {
            this.registerData.ShippingServiceIdAuction = shippingService.id;
            this.selectedShippingServiceAuction = shippingService;
        },
        get showRegionInput() {
            var _a;
            return RegionRequiredCountries.includes((_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.countryCode);
        },
    };
}
